<template>
  <div class="pull-left leftSidebar">
    <ul class="nav">
      <li class="title">账户中心</li>
      <li :class="routeName(['profile'])">
        <a href="https://account.xueersi.com/Webs/index/#/profile">我的资料</a>
      </li>
      <li :class="routeName(['password'])">
        <a href="https://account.xueersi.com/Webs/pwdMgr/#/password">修改密码</a>
      </li>
      <li :class="routeName(['setPhone'])">
        <a href="https://account.xueersi.com/Webs/phoneMgr/#/setPhone">修改手机号</a>
      </li>
      <li :class="routeName(['setAddress'])">
        <a href="https://account.xueersi.com/Webs/addrMgr/#/setAddress">收货地址</a>
      </li>
      <!-- <li :class="routeName(['bindAccount'])">
        <a href="https://account.xueersi.com/Webs/platMgr/#/bindAccount"
          >第三方账户绑定</a
        >
      </li> -->
      <!-- <li class="title">用户中心</li> -->
      <!-- <li :class="routeName(['continueSign'])">
        <a :href='continueSignUrl'>老学员报名</a>
      </li> -->
      <!-- <li :class="routeName(['changeCourse'])">
        <a :href="changeCourseUrl">跨版本难度换课</a>
      </li> -->
      <li class="title">订单中心</li>
      <li :class="routeName(['orderList', 'orderDetail', 'OrderDrop', 'OrderDropEcard'])">
        <a :href="myOrderUrl">我的订单</a>
      </li>
      <li :class="routeName(['bill'])"><a :href="billUrl">我的发票</a></li>
      <li class="title">资产中心</li>
      <li :class="routeName(['balance'])">
        <a :href="balanceUrl">我的余额</a>
      </li>
      <li :class="routeName(['coupon', 'couponActive'])">
        <a :href="couponUrl">优惠券</a>
      </li>
      <li :class="routeName(['sendCard', 'activeCard', 'classItem', 'exchange', 'exchangeRecord'])">
        <a :href="learnCardUrl">学习卡</a>
      </li>
      <li :class="routeName(['giftCard'])">
        <a :href="giftCardUrl">礼品卡</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { business } from '@xes/trade-toolkit'
export default {
  name: 'Left',
  data() {
    const biz = business.getCurrentBizId()
    return {
      biz
    }
  },
  mounted() {
    window.app = this
  },

  computed: {
    // changeCourse
    changeCourseUrl() {
      return `https://home.xueersi.com/changeCourse/?app_blid=${this.biz}`
    },
    // 我的余额
    balanceUrl() {
      return `https://ocenter.xueersi.com/Ocenter/balance/?app_blid=${this.biz}#/balance`
    },
    // 我的订单
    myOrderUrl() {
      return `https://ocenter.xueersi.com/MyOrders/show/?app_blid=${this.biz}#/MyOrders/list/0/1`
    },
    // 我的发票
    billUrl() {
      return `https://ocenter.xueersi.com/Ocenter/invoice/?app_blid=${this.biz}#/bill`
    },
    // 优惠券
    couponUrl() {
      return `https://app.xueersi.com/cardcouponweb/couponWeb/?app_blid=${this.biz}#/coupon`
    },
    // 学习卡
    learnCardUrl() {
      return `https://ocenter.xueersi.com/Ocenter/sendCard/?app_blid=${this.biz}#/account/card`
    },
    giftCardUrl() {
      return `https://app.xueersi.com/cardcouponweb/giftCardWeb/?app_blid=${this.biz}#/giftCard`
    },
    continueSignUrl() {
      return `https://home.xueersi.com/continueSign/?app_blid=${this.biz}`
    },
    routePath() {
      return this.$route.path
    }
  },
  methods: {
    // 根据路由匹配left左栏的高亮
    routeName(arr) {
      let name = this.$route.name
      for (let i = 0, len = arr.length; i < len; i++) {
        if (arr[i] == name) {
          return 'active'
        }
      }
      return ''
    }
  }
}
</script>

<style lang="less" scoped>
.pull-left {
  float: left;
}
.leftSidebar {
  width: 190px;
  min-height: 630px;
  margin-right: 10px;
  background: #fff;
  .nav {
    padding: 0px 0 0 40px;
    .title {
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      margin-top: 20px;
      height: 35px;
      line-height: 35px;
    }
    .active {
      a {
        color: #f13232;
      }
    }
    a {
      color: #666;
      font-size: 14px;
      display: block;
      height: 34px;
      line-height: 34px;
      &:hover {
        color: #f13232;
      }
      &.router-link-active {
        color: #f13232;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// common/components/ocenter/Left.vue